import React, { useState } from 'react';
import PinName from '../../Comman Components/Pinterest Componets/PinName';
import PinImage from '../../Comman Components/Pinterest Componets/PinImage';
import defaultPreviewPlaceholder from '../../Assets/dummy_images/default-preview-placeholder.png';

export default function Pinerest({ Previewimages: mediaItems = [], pinTitle = '', pinDescription = '', profile, thumbnailUrl }) {
  const [open, setOpen] = useState(true);

  const renderMedia = () => {
    if (!mediaItems || mediaItems.length === 0) {
      return (
        <img
          src={defaultPreviewPlaceholder}
          alt="Default preview"
          className="w-full h-auto max-h-96 object-cover rounded-lg"
        />
      );
    }

    const item = mediaItems[0];
    const isVideo = item.type === 'video';

    if (isVideo && thumbnailUrl) {
      return (
        <div className="relative bg-black rounded-lg">
          <img
            src={thumbnailUrl}
            className="w-full h-auto max-h-96 object-cover rounded-lg"
            alt="Pinterest pin thumbnail preview"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 rounded-lg">
            <i className="fa-solid fa-play text-white text-4xl opacity-80"></i>
          </div>
        </div>
      );
    }

    const urlToRender = item.permanentUrl || item.localUrl;

    if (isVideo) {
      return (
        <video
          src={urlToRender}
          controls
          className="w-full h-auto max-h-96 object-contain bg-black rounded-lg"
        />
      );
    }

    return (
      <img
        src={urlToRender}
        className="w-full h-auto max-h-96 object-cover rounded-lg"
        alt="Pinterest pin preview"
      />
    );
  };

  return (
    <div className="w-full max-w-sm mx-auto my-4 border border-gray-300 rounded-xl">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-3 font-semibold text-left"
      >
        <div className="flex items-center gap-2">
          <i className="fa-brands fa-pinterest text-red-600 text-lg"></i>
          <span>Pinterest</span>
        </div>
        <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"} text-gray-400`}></i>
      </button>

      {open && (
        <div className="p-3 border-t">
          <div className="bg-gray-100 rounded-lg p-2">
            {renderMedia()}
            <div className="mt-2 px-1 space-y-1">
              <h3 className="font-bold text-sm break-words">
                {pinTitle || <span className="text-gray-400 italic">Your pin title will appear here...</span>}
              </h3>
              <p className="text-xs text-gray-600 break-words">
                {pinDescription || <span className="text-gray-400 italic">Your main caption will be the description...</span>}
              </p>
              <div className="flex items-center gap-2 pt-2">
                {profile ? (
                  <PinImage Id={profile.platform_id} />
                ) : (
                  <img
                    src={defaultPreviewPlaceholder}
                    alt="Default profile"
                    className="w-9 h-9 rounded-full object-cover"
                  />
                )}
                <div className="text-xs font-semibold">
                  {profile ? <PinName Id={profile.platform_id} /> : "Pinterest User"}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}